import { Component, forwardRef, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-d-date-range',
  templateUrl: './d-date-range.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DDateRangeComponent),
      multi: true
    }
  ]
})
export class DDateRangeComponent extends DynamicComponentBase {
  static KEY = 'd-date-range';

  constructor() {
    super();
  }
  dateFormat = 'yyyy-MM-dd';

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.allowClear !== 'boolean') {
      config.allowClear = true;
    }
    // config.value = '2020-12-12,2020-12-20';
    // if (config.value && config.value.length) {
    //   let arr = config.value.split(',');
    //   config.value = arr;
    // }
    // if (config.placeholder && config.placeholder.length) {
    //   let arr = config.placeholder.split(',');
    //   config.placeholder = arr;
    // }
  }
}
